import styled from 'styled-components/macro';

export const HeaderRow = styled.div`
  height: 5rem;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;

  @media (max-width: 1366px) {
    height: 45px;
  }
`;

export const PageInfoContentWrapper = styled.div`
  height: 100%;
`;

export const BackButton = styled.div`
  padding: 0 10px;
  cursor: pointer;
`;

export const RowDivider = styled.div`
  background-color: #edf3f7;
  height: 0.5rem;
  margin-right: -15px;
  margin-left: -15px;
`;

export const ZendeskContainerRow = styled.div`
  height: calc(100% - 47px);
  overflow-y: scroll;
`;
